import React from 'react';
import Icon from './Icon';

const ViewIcon = (props) => (
    <Icon {...props}>
        <path
            d="M2.5 12C4.5 7.5 8 6 12 6C16 6 19.5 7.5 21.5 12C19.5 16.5 16 18 12 18C8 18 4.5 16.5 2.5 12ZM15 12A3 3 0 1 1 9 12A3 3 0 0 1 15 12"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ViewIcon;